/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as PaymentsSecure3dsRouteImport } from './routes/payments/secure3ds'
import { Route as DashboardStatisticsRouteImport } from './routes/dashboard/statistics'
import { Route as DashboardProfileRouteImport } from './routes/dashboard/profile'
import { Route as DashboardPickupScheduleRouteImport } from './routes/dashboard/pickup-schedule'
import { Route as DashboardPackagesPriceRouteImport } from './routes/dashboard/packages-price'
import { Route as DashboardPackageOptionsRouteImport } from './routes/dashboard/package-options'
import { Route as DashboardOrdersRouteImport } from './routes/dashboard/orders'
import { Route as DashboardFocusRouteImport } from './routes/dashboard/focus'
import { Route as DashboardDocumentsRouteImport } from './routes/dashboard/documents'
import { Route as DashboardDirectionsRouteImport } from './routes/dashboard/directions'
import { Route as DashboardCouriersMapRouteImport } from './routes/dashboard/couriers-map'
import { Route as DashboardCourier_packages_acceptRouteImport } from './routes/dashboard/courier_packages_accept'
import { Route as DashboardCourier_orders_acceptRouteImport } from './routes/dashboard/courier_orders_accept'
import { Route as DashboardContactsRouteImport } from './routes/dashboard/contacts'
import { Route as DashboardCitiesRouteImport } from './routes/dashboard/cities'
import { Route as DashboardBlackListRouteImport } from './routes/dashboard/black-list'
import { Route as DashboardBannersRouteImport } from './routes/dashboard/banners'
import { Route as DashboardAssignRouteImport } from './routes/dashboard/assign'
import { Route as DashboardAppVersionsRouteImport } from './routes/dashboard/app-versions'
import { Route as DashboardUsersIndexRouteImport } from './routes/dashboard/users/index'
import { Route as DashboardTariffsIndexRouteImport } from './routes/dashboard/tariffs/index'
import { Route as DashboardOrderIndexRouteImport } from './routes/dashboard/order/index'
import { Route as DashboardCategoriesIndexRouteImport } from './routes/dashboard/categories/index'
import { Route as DashboardUsersUserIdRouteImport } from './routes/dashboard/users/$userId'
import { Route as DashboardOrderAddRouteImport } from './routes/dashboard/order/add'
import { Route as DashboardTariffConfigurationIndexRouteImport } from './routes/dashboard/tariff/configuration/index'
import { Route as DashboardOrderAccumulatorsIndexRouteImport } from './routes/dashboard/order/accumulators/index'
import { Route as DashboardOrderOrderIdIndexRouteImport } from './routes/dashboard/order/$orderId/index'
import { Route as DashboardCategoriesCategoryIdIndexRouteImport } from './routes/dashboard/categories/$categoryId/index'
import { Route as DashboardTariffConfigurationAddRouteImport } from './routes/dashboard/tariff/configuration/add'
import { Route as DashboardOrderOrderIdEditRouteImport } from './routes/dashboard/order/$orderId/edit'
import { Route as DashboardOrderAccumulatorsAccumulatorIdIndexRouteImport } from './routes/dashboard/order/accumulators/$accumulatorId/index'
import { Route as DashboardTariffConfigurationConfigurationIdEditRouteImport } from './routes/dashboard/tariff/configuration/$configurationId/edit'
import { Route as DashboardCategoriesCategoryIdTariffsAddRouteImport } from './routes/dashboard/categories/$categoryId/tariffs/add'
import { Route as DashboardCategoriesCategoryIdTariffsTariffIdEditRouteImport } from './routes/dashboard/categories/$categoryId/tariffs/$tariffId/edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const PaymentsSecure3dsRoute = PaymentsSecure3dsRouteImport.update({
  id: '/payments/secure3ds',
  path: '/payments/secure3ds',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardStatisticsRoute = DashboardStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPickupScheduleRoute = DashboardPickupScheduleRouteImport.update({
  id: '/pickup-schedule',
  path: '/pickup-schedule',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPackagesPriceRoute = DashboardPackagesPriceRouteImport.update({
  id: '/packages-price',
  path: '/packages-price',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPackageOptionsRoute = DashboardPackageOptionsRouteImport.update({
  id: '/package-options',
  path: '/package-options',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOrdersRoute = DashboardOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardFocusRoute = DashboardFocusRouteImport.update({
  id: '/focus',
  path: '/focus',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDocumentsRoute = DashboardDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDirectionsRoute = DashboardDirectionsRouteImport.update({
  id: '/directions',
  path: '/directions',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCouriersMapRoute = DashboardCouriersMapRouteImport.update({
  id: '/couriers-map',
  path: '/couriers-map',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCourier_packages_acceptRoute =
  DashboardCourier_packages_acceptRouteImport.update({
    id: '/courier_packages_accept',
    path: '/courier_packages_accept',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCourier_orders_acceptRoute =
  DashboardCourier_orders_acceptRouteImport.update({
    id: '/courier_orders_accept',
    path: '/courier_orders_accept',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardContactsRoute = DashboardContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCitiesRoute = DashboardCitiesRouteImport.update({
  id: '/cities',
  path: '/cities',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBlackListRoute = DashboardBlackListRouteImport.update({
  id: '/black-list',
  path: '/black-list',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBannersRoute = DashboardBannersRouteImport.update({
  id: '/banners',
  path: '/banners',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAssignRoute = DashboardAssignRouteImport.update({
  id: '/assign',
  path: '/assign',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAppVersionsRoute = DashboardAppVersionsRouteImport.update({
  id: '/app-versions',
  path: '/app-versions',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTariffsIndexRoute = DashboardTariffsIndexRouteImport.update({
  id: '/tariffs/',
  path: '/tariffs/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOrderIndexRoute = DashboardOrderIndexRouteImport.update({
  id: '/order/',
  path: '/order/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCategoriesIndexRoute =
  DashboardCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardUsersUserIdRoute = DashboardUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOrderAddRoute = DashboardOrderAddRouteImport.update({
  id: '/order/add',
  path: '/order/add',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTariffConfigurationIndexRoute =
  DashboardTariffConfigurationIndexRouteImport.update({
    id: '/tariff/configuration/',
    path: '/tariff/configuration/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOrderAccumulatorsIndexRoute =
  DashboardOrderAccumulatorsIndexRouteImport.update({
    id: '/order/accumulators/',
    path: '/order/accumulators/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOrderOrderIdIndexRoute =
  DashboardOrderOrderIdIndexRouteImport.update({
    id: '/order/$orderId/',
    path: '/order/$orderId/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCategoriesCategoryIdIndexRoute =
  DashboardCategoriesCategoryIdIndexRouteImport.update({
    id: '/categories/$categoryId/',
    path: '/categories/$categoryId/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTariffConfigurationAddRoute =
  DashboardTariffConfigurationAddRouteImport.update({
    id: '/tariff/configuration/add',
    path: '/tariff/configuration/add',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOrderOrderIdEditRoute =
  DashboardOrderOrderIdEditRouteImport.update({
    id: '/order/$orderId/edit',
    path: '/order/$orderId/edit',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOrderAccumulatorsAccumulatorIdIndexRoute =
  DashboardOrderAccumulatorsAccumulatorIdIndexRouteImport.update({
    id: '/order/accumulators/$accumulatorId/',
    path: '/order/accumulators/$accumulatorId/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTariffConfigurationConfigurationIdEditRoute =
  DashboardTariffConfigurationConfigurationIdEditRouteImport.update({
    id: '/tariff/configuration/$configurationId/edit',
    path: '/tariff/configuration/$configurationId/edit',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCategoriesCategoryIdTariffsAddRoute =
  DashboardCategoriesCategoryIdTariffsAddRouteImport.update({
    id: '/categories/$categoryId/tariffs/add',
    path: '/categories/$categoryId/tariffs/add',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCategoriesCategoryIdTariffsTariffIdEditRoute =
  DashboardCategoriesCategoryIdTariffsTariffIdEditRouteImport.update({
    id: '/categories/$categoryId/tariffs/$tariffId/edit',
    path: '/categories/$categoryId/tariffs/$tariffId/edit',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/app-versions': typeof DashboardAppVersionsRoute
  '/dashboard/assign': typeof DashboardAssignRoute
  '/dashboard/banners': typeof DashboardBannersRoute
  '/dashboard/black-list': typeof DashboardBlackListRoute
  '/dashboard/cities': typeof DashboardCitiesRoute
  '/dashboard/contacts': typeof DashboardContactsRoute
  '/dashboard/courier_orders_accept': typeof DashboardCourier_orders_acceptRoute
  '/dashboard/courier_packages_accept': typeof DashboardCourier_packages_acceptRoute
  '/dashboard/couriers-map': typeof DashboardCouriersMapRoute
  '/dashboard/directions': typeof DashboardDirectionsRoute
  '/dashboard/documents': typeof DashboardDocumentsRoute
  '/dashboard/focus': typeof DashboardFocusRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/package-options': typeof DashboardPackageOptionsRoute
  '/dashboard/packages-price': typeof DashboardPackagesPriceRoute
  '/dashboard/pickup-schedule': typeof DashboardPickupScheduleRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/statistics': typeof DashboardStatisticsRoute
  '/payments/secure3ds': typeof PaymentsSecure3dsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/order/add': typeof DashboardOrderAddRoute
  '/dashboard/users/$userId': typeof DashboardUsersUserIdRoute
  '/dashboard/categories': typeof DashboardCategoriesIndexRoute
  '/dashboard/order': typeof DashboardOrderIndexRoute
  '/dashboard/tariffs': typeof DashboardTariffsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/order/$orderId/edit': typeof DashboardOrderOrderIdEditRoute
  '/dashboard/tariff/configuration/add': typeof DashboardTariffConfigurationAddRoute
  '/dashboard/categories/$categoryId': typeof DashboardCategoriesCategoryIdIndexRoute
  '/dashboard/order/$orderId': typeof DashboardOrderOrderIdIndexRoute
  '/dashboard/order/accumulators': typeof DashboardOrderAccumulatorsIndexRoute
  '/dashboard/tariff/configuration': typeof DashboardTariffConfigurationIndexRoute
  '/dashboard/categories/$categoryId/tariffs/add': typeof DashboardCategoriesCategoryIdTariffsAddRoute
  '/dashboard/tariff/configuration/$configurationId/edit': typeof DashboardTariffConfigurationConfigurationIdEditRoute
  '/dashboard/order/accumulators/$accumulatorId': typeof DashboardOrderAccumulatorsAccumulatorIdIndexRoute
  '/dashboard/categories/$categoryId/tariffs/$tariffId/edit': typeof DashboardCategoriesCategoryIdTariffsTariffIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard/app-versions': typeof DashboardAppVersionsRoute
  '/dashboard/assign': typeof DashboardAssignRoute
  '/dashboard/banners': typeof DashboardBannersRoute
  '/dashboard/black-list': typeof DashboardBlackListRoute
  '/dashboard/cities': typeof DashboardCitiesRoute
  '/dashboard/contacts': typeof DashboardContactsRoute
  '/dashboard/courier_orders_accept': typeof DashboardCourier_orders_acceptRoute
  '/dashboard/courier_packages_accept': typeof DashboardCourier_packages_acceptRoute
  '/dashboard/couriers-map': typeof DashboardCouriersMapRoute
  '/dashboard/directions': typeof DashboardDirectionsRoute
  '/dashboard/documents': typeof DashboardDocumentsRoute
  '/dashboard/focus': typeof DashboardFocusRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/package-options': typeof DashboardPackageOptionsRoute
  '/dashboard/packages-price': typeof DashboardPackagesPriceRoute
  '/dashboard/pickup-schedule': typeof DashboardPickupScheduleRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/statistics': typeof DashboardStatisticsRoute
  '/payments/secure3ds': typeof PaymentsSecure3dsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/order/add': typeof DashboardOrderAddRoute
  '/dashboard/users/$userId': typeof DashboardUsersUserIdRoute
  '/dashboard/categories': typeof DashboardCategoriesIndexRoute
  '/dashboard/order': typeof DashboardOrderIndexRoute
  '/dashboard/tariffs': typeof DashboardTariffsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/order/$orderId/edit': typeof DashboardOrderOrderIdEditRoute
  '/dashboard/tariff/configuration/add': typeof DashboardTariffConfigurationAddRoute
  '/dashboard/categories/$categoryId': typeof DashboardCategoriesCategoryIdIndexRoute
  '/dashboard/order/$orderId': typeof DashboardOrderOrderIdIndexRoute
  '/dashboard/order/accumulators': typeof DashboardOrderAccumulatorsIndexRoute
  '/dashboard/tariff/configuration': typeof DashboardTariffConfigurationIndexRoute
  '/dashboard/categories/$categoryId/tariffs/add': typeof DashboardCategoriesCategoryIdTariffsAddRoute
  '/dashboard/tariff/configuration/$configurationId/edit': typeof DashboardTariffConfigurationConfigurationIdEditRoute
  '/dashboard/order/accumulators/$accumulatorId': typeof DashboardOrderAccumulatorsAccumulatorIdIndexRoute
  '/dashboard/categories/$categoryId/tariffs/$tariffId/edit': typeof DashboardCategoriesCategoryIdTariffsTariffIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/app-versions': typeof DashboardAppVersionsRoute
  '/dashboard/assign': typeof DashboardAssignRoute
  '/dashboard/banners': typeof DashboardBannersRoute
  '/dashboard/black-list': typeof DashboardBlackListRoute
  '/dashboard/cities': typeof DashboardCitiesRoute
  '/dashboard/contacts': typeof DashboardContactsRoute
  '/dashboard/courier_orders_accept': typeof DashboardCourier_orders_acceptRoute
  '/dashboard/courier_packages_accept': typeof DashboardCourier_packages_acceptRoute
  '/dashboard/couriers-map': typeof DashboardCouriersMapRoute
  '/dashboard/directions': typeof DashboardDirectionsRoute
  '/dashboard/documents': typeof DashboardDocumentsRoute
  '/dashboard/focus': typeof DashboardFocusRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/package-options': typeof DashboardPackageOptionsRoute
  '/dashboard/packages-price': typeof DashboardPackagesPriceRoute
  '/dashboard/pickup-schedule': typeof DashboardPickupScheduleRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/statistics': typeof DashboardStatisticsRoute
  '/payments/secure3ds': typeof PaymentsSecure3dsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/order/add': typeof DashboardOrderAddRoute
  '/dashboard/users/$userId': typeof DashboardUsersUserIdRoute
  '/dashboard/categories/': typeof DashboardCategoriesIndexRoute
  '/dashboard/order/': typeof DashboardOrderIndexRoute
  '/dashboard/tariffs/': typeof DashboardTariffsIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/order/$orderId/edit': typeof DashboardOrderOrderIdEditRoute
  '/dashboard/tariff/configuration/add': typeof DashboardTariffConfigurationAddRoute
  '/dashboard/categories/$categoryId/': typeof DashboardCategoriesCategoryIdIndexRoute
  '/dashboard/order/$orderId/': typeof DashboardOrderOrderIdIndexRoute
  '/dashboard/order/accumulators/': typeof DashboardOrderAccumulatorsIndexRoute
  '/dashboard/tariff/configuration/': typeof DashboardTariffConfigurationIndexRoute
  '/dashboard/categories/$categoryId/tariffs/add': typeof DashboardCategoriesCategoryIdTariffsAddRoute
  '/dashboard/tariff/configuration/$configurationId/edit': typeof DashboardTariffConfigurationConfigurationIdEditRoute
  '/dashboard/order/accumulators/$accumulatorId/': typeof DashboardOrderAccumulatorsAccumulatorIdIndexRoute
  '/dashboard/categories/$categoryId/tariffs/$tariffId/edit': typeof DashboardCategoriesCategoryIdTariffsTariffIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/app-versions'
    | '/dashboard/assign'
    | '/dashboard/banners'
    | '/dashboard/black-list'
    | '/dashboard/cities'
    | '/dashboard/contacts'
    | '/dashboard/courier_orders_accept'
    | '/dashboard/courier_packages_accept'
    | '/dashboard/couriers-map'
    | '/dashboard/directions'
    | '/dashboard/documents'
    | '/dashboard/focus'
    | '/dashboard/orders'
    | '/dashboard/package-options'
    | '/dashboard/packages-price'
    | '/dashboard/pickup-schedule'
    | '/dashboard/profile'
    | '/dashboard/statistics'
    | '/payments/secure3ds'
    | '/dashboard/'
    | '/dashboard/order/add'
    | '/dashboard/users/$userId'
    | '/dashboard/categories'
    | '/dashboard/order'
    | '/dashboard/tariffs'
    | '/dashboard/users'
    | '/dashboard/order/$orderId/edit'
    | '/dashboard/tariff/configuration/add'
    | '/dashboard/categories/$categoryId'
    | '/dashboard/order/$orderId'
    | '/dashboard/order/accumulators'
    | '/dashboard/tariff/configuration'
    | '/dashboard/categories/$categoryId/tariffs/add'
    | '/dashboard/tariff/configuration/$configurationId/edit'
    | '/dashboard/order/accumulators/$accumulatorId'
    | '/dashboard/categories/$categoryId/tariffs/$tariffId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard/app-versions'
    | '/dashboard/assign'
    | '/dashboard/banners'
    | '/dashboard/black-list'
    | '/dashboard/cities'
    | '/dashboard/contacts'
    | '/dashboard/courier_orders_accept'
    | '/dashboard/courier_packages_accept'
    | '/dashboard/couriers-map'
    | '/dashboard/directions'
    | '/dashboard/documents'
    | '/dashboard/focus'
    | '/dashboard/orders'
    | '/dashboard/package-options'
    | '/dashboard/packages-price'
    | '/dashboard/pickup-schedule'
    | '/dashboard/profile'
    | '/dashboard/statistics'
    | '/payments/secure3ds'
    | '/dashboard'
    | '/dashboard/order/add'
    | '/dashboard/users/$userId'
    | '/dashboard/categories'
    | '/dashboard/order'
    | '/dashboard/tariffs'
    | '/dashboard/users'
    | '/dashboard/order/$orderId/edit'
    | '/dashboard/tariff/configuration/add'
    | '/dashboard/categories/$categoryId'
    | '/dashboard/order/$orderId'
    | '/dashboard/order/accumulators'
    | '/dashboard/tariff/configuration'
    | '/dashboard/categories/$categoryId/tariffs/add'
    | '/dashboard/tariff/configuration/$configurationId/edit'
    | '/dashboard/order/accumulators/$accumulatorId'
    | '/dashboard/categories/$categoryId/tariffs/$tariffId/edit'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/app-versions'
    | '/dashboard/assign'
    | '/dashboard/banners'
    | '/dashboard/black-list'
    | '/dashboard/cities'
    | '/dashboard/contacts'
    | '/dashboard/courier_orders_accept'
    | '/dashboard/courier_packages_accept'
    | '/dashboard/couriers-map'
    | '/dashboard/directions'
    | '/dashboard/documents'
    | '/dashboard/focus'
    | '/dashboard/orders'
    | '/dashboard/package-options'
    | '/dashboard/packages-price'
    | '/dashboard/pickup-schedule'
    | '/dashboard/profile'
    | '/dashboard/statistics'
    | '/payments/secure3ds'
    | '/dashboard/'
    | '/dashboard/order/add'
    | '/dashboard/users/$userId'
    | '/dashboard/categories/'
    | '/dashboard/order/'
    | '/dashboard/tariffs/'
    | '/dashboard/users/'
    | '/dashboard/order/$orderId/edit'
    | '/dashboard/tariff/configuration/add'
    | '/dashboard/categories/$categoryId/'
    | '/dashboard/order/$orderId/'
    | '/dashboard/order/accumulators/'
    | '/dashboard/tariff/configuration/'
    | '/dashboard/categories/$categoryId/tariffs/add'
    | '/dashboard/tariff/configuration/$configurationId/edit'
    | '/dashboard/order/accumulators/$accumulatorId/'
    | '/dashboard/categories/$categoryId/tariffs/$tariffId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  PaymentsSecure3dsRoute: typeof PaymentsSecure3dsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/payments/secure3ds': {
      id: '/payments/secure3ds'
      path: '/payments/secure3ds'
      fullPath: '/payments/secure3ds'
      preLoaderRoute: typeof PaymentsSecure3dsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/statistics': {
      id: '/dashboard/statistics'
      path: '/statistics'
      fullPath: '/dashboard/statistics'
      preLoaderRoute: typeof DashboardStatisticsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/pickup-schedule': {
      id: '/dashboard/pickup-schedule'
      path: '/pickup-schedule'
      fullPath: '/dashboard/pickup-schedule'
      preLoaderRoute: typeof DashboardPickupScheduleRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/packages-price': {
      id: '/dashboard/packages-price'
      path: '/packages-price'
      fullPath: '/dashboard/packages-price'
      preLoaderRoute: typeof DashboardPackagesPriceRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/package-options': {
      id: '/dashboard/package-options'
      path: '/package-options'
      fullPath: '/dashboard/package-options'
      preLoaderRoute: typeof DashboardPackageOptionsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/orders': {
      id: '/dashboard/orders'
      path: '/orders'
      fullPath: '/dashboard/orders'
      preLoaderRoute: typeof DashboardOrdersRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/focus': {
      id: '/dashboard/focus'
      path: '/focus'
      fullPath: '/dashboard/focus'
      preLoaderRoute: typeof DashboardFocusRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/documents': {
      id: '/dashboard/documents'
      path: '/documents'
      fullPath: '/dashboard/documents'
      preLoaderRoute: typeof DashboardDocumentsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/directions': {
      id: '/dashboard/directions'
      path: '/directions'
      fullPath: '/dashboard/directions'
      preLoaderRoute: typeof DashboardDirectionsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/couriers-map': {
      id: '/dashboard/couriers-map'
      path: '/couriers-map'
      fullPath: '/dashboard/couriers-map'
      preLoaderRoute: typeof DashboardCouriersMapRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/courier_packages_accept': {
      id: '/dashboard/courier_packages_accept'
      path: '/courier_packages_accept'
      fullPath: '/dashboard/courier_packages_accept'
      preLoaderRoute: typeof DashboardCourier_packages_acceptRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/courier_orders_accept': {
      id: '/dashboard/courier_orders_accept'
      path: '/courier_orders_accept'
      fullPath: '/dashboard/courier_orders_accept'
      preLoaderRoute: typeof DashboardCourier_orders_acceptRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/contacts': {
      id: '/dashboard/contacts'
      path: '/contacts'
      fullPath: '/dashboard/contacts'
      preLoaderRoute: typeof DashboardContactsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/cities': {
      id: '/dashboard/cities'
      path: '/cities'
      fullPath: '/dashboard/cities'
      preLoaderRoute: typeof DashboardCitiesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/black-list': {
      id: '/dashboard/black-list'
      path: '/black-list'
      fullPath: '/dashboard/black-list'
      preLoaderRoute: typeof DashboardBlackListRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/banners': {
      id: '/dashboard/banners'
      path: '/banners'
      fullPath: '/dashboard/banners'
      preLoaderRoute: typeof DashboardBannersRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/assign': {
      id: '/dashboard/assign'
      path: '/assign'
      fullPath: '/dashboard/assign'
      preLoaderRoute: typeof DashboardAssignRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/app-versions': {
      id: '/dashboard/app-versions'
      path: '/app-versions'
      fullPath: '/dashboard/app-versions'
      preLoaderRoute: typeof DashboardAppVersionsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/users/': {
      id: '/dashboard/users/'
      path: '/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tariffs/': {
      id: '/dashboard/tariffs/'
      path: '/tariffs'
      fullPath: '/dashboard/tariffs'
      preLoaderRoute: typeof DashboardTariffsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/order/': {
      id: '/dashboard/order/'
      path: '/order'
      fullPath: '/dashboard/order'
      preLoaderRoute: typeof DashboardOrderIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/categories/': {
      id: '/dashboard/categories/'
      path: '/categories'
      fullPath: '/dashboard/categories'
      preLoaderRoute: typeof DashboardCategoriesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/users/$userId': {
      id: '/dashboard/users/$userId'
      path: '/users/$userId'
      fullPath: '/dashboard/users/$userId'
      preLoaderRoute: typeof DashboardUsersUserIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/order/add': {
      id: '/dashboard/order/add'
      path: '/order/add'
      fullPath: '/dashboard/order/add'
      preLoaderRoute: typeof DashboardOrderAddRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tariff/configuration/': {
      id: '/dashboard/tariff/configuration/'
      path: '/tariff/configuration'
      fullPath: '/dashboard/tariff/configuration'
      preLoaderRoute: typeof DashboardTariffConfigurationIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/order/accumulators/': {
      id: '/dashboard/order/accumulators/'
      path: '/order/accumulators'
      fullPath: '/dashboard/order/accumulators'
      preLoaderRoute: typeof DashboardOrderAccumulatorsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/order/$orderId/': {
      id: '/dashboard/order/$orderId/'
      path: '/order/$orderId'
      fullPath: '/dashboard/order/$orderId'
      preLoaderRoute: typeof DashboardOrderOrderIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/categories/$categoryId/': {
      id: '/dashboard/categories/$categoryId/'
      path: '/categories/$categoryId'
      fullPath: '/dashboard/categories/$categoryId'
      preLoaderRoute: typeof DashboardCategoriesCategoryIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tariff/configuration/add': {
      id: '/dashboard/tariff/configuration/add'
      path: '/tariff/configuration/add'
      fullPath: '/dashboard/tariff/configuration/add'
      preLoaderRoute: typeof DashboardTariffConfigurationAddRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/order/$orderId/edit': {
      id: '/dashboard/order/$orderId/edit'
      path: '/order/$orderId/edit'
      fullPath: '/dashboard/order/$orderId/edit'
      preLoaderRoute: typeof DashboardOrderOrderIdEditRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/order/accumulators/$accumulatorId/': {
      id: '/dashboard/order/accumulators/$accumulatorId/'
      path: '/order/accumulators/$accumulatorId'
      fullPath: '/dashboard/order/accumulators/$accumulatorId'
      preLoaderRoute: typeof DashboardOrderAccumulatorsAccumulatorIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tariff/configuration/$configurationId/edit': {
      id: '/dashboard/tariff/configuration/$configurationId/edit'
      path: '/tariff/configuration/$configurationId/edit'
      fullPath: '/dashboard/tariff/configuration/$configurationId/edit'
      preLoaderRoute: typeof DashboardTariffConfigurationConfigurationIdEditRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/categories/$categoryId/tariffs/add': {
      id: '/dashboard/categories/$categoryId/tariffs/add'
      path: '/categories/$categoryId/tariffs/add'
      fullPath: '/dashboard/categories/$categoryId/tariffs/add'
      preLoaderRoute: typeof DashboardCategoriesCategoryIdTariffsAddRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/categories/$categoryId/tariffs/$tariffId/edit': {
      id: '/dashboard/categories/$categoryId/tariffs/$tariffId/edit'
      path: '/categories/$categoryId/tariffs/$tariffId/edit'
      fullPath: '/dashboard/categories/$categoryId/tariffs/$tariffId/edit'
      preLoaderRoute: typeof DashboardCategoriesCategoryIdTariffsTariffIdEditRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardRouteRouteChildren {
  DashboardAppVersionsRoute: typeof DashboardAppVersionsRoute
  DashboardAssignRoute: typeof DashboardAssignRoute
  DashboardBannersRoute: typeof DashboardBannersRoute
  DashboardBlackListRoute: typeof DashboardBlackListRoute
  DashboardCitiesRoute: typeof DashboardCitiesRoute
  DashboardContactsRoute: typeof DashboardContactsRoute
  DashboardCourier_orders_acceptRoute: typeof DashboardCourier_orders_acceptRoute
  DashboardCourier_packages_acceptRoute: typeof DashboardCourier_packages_acceptRoute
  DashboardCouriersMapRoute: typeof DashboardCouriersMapRoute
  DashboardDirectionsRoute: typeof DashboardDirectionsRoute
  DashboardDocumentsRoute: typeof DashboardDocumentsRoute
  DashboardFocusRoute: typeof DashboardFocusRoute
  DashboardOrdersRoute: typeof DashboardOrdersRoute
  DashboardPackageOptionsRoute: typeof DashboardPackageOptionsRoute
  DashboardPackagesPriceRoute: typeof DashboardPackagesPriceRoute
  DashboardPickupScheduleRoute: typeof DashboardPickupScheduleRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardStatisticsRoute: typeof DashboardStatisticsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardOrderAddRoute: typeof DashboardOrderAddRoute
  DashboardUsersUserIdRoute: typeof DashboardUsersUserIdRoute
  DashboardCategoriesIndexRoute: typeof DashboardCategoriesIndexRoute
  DashboardOrderIndexRoute: typeof DashboardOrderIndexRoute
  DashboardTariffsIndexRoute: typeof DashboardTariffsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardOrderOrderIdEditRoute: typeof DashboardOrderOrderIdEditRoute
  DashboardTariffConfigurationAddRoute: typeof DashboardTariffConfigurationAddRoute
  DashboardCategoriesCategoryIdIndexRoute: typeof DashboardCategoriesCategoryIdIndexRoute
  DashboardOrderOrderIdIndexRoute: typeof DashboardOrderOrderIdIndexRoute
  DashboardOrderAccumulatorsIndexRoute: typeof DashboardOrderAccumulatorsIndexRoute
  DashboardTariffConfigurationIndexRoute: typeof DashboardTariffConfigurationIndexRoute
  DashboardCategoriesCategoryIdTariffsAddRoute: typeof DashboardCategoriesCategoryIdTariffsAddRoute
  DashboardTariffConfigurationConfigurationIdEditRoute: typeof DashboardTariffConfigurationConfigurationIdEditRoute
  DashboardOrderAccumulatorsAccumulatorIdIndexRoute: typeof DashboardOrderAccumulatorsAccumulatorIdIndexRoute
  DashboardCategoriesCategoryIdTariffsTariffIdEditRoute: typeof DashboardCategoriesCategoryIdTariffsTariffIdEditRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAppVersionsRoute: DashboardAppVersionsRoute,
  DashboardAssignRoute: DashboardAssignRoute,
  DashboardBannersRoute: DashboardBannersRoute,
  DashboardBlackListRoute: DashboardBlackListRoute,
  DashboardCitiesRoute: DashboardCitiesRoute,
  DashboardContactsRoute: DashboardContactsRoute,
  DashboardCourier_orders_acceptRoute: DashboardCourier_orders_acceptRoute,
  DashboardCourier_packages_acceptRoute: DashboardCourier_packages_acceptRoute,
  DashboardCouriersMapRoute: DashboardCouriersMapRoute,
  DashboardDirectionsRoute: DashboardDirectionsRoute,
  DashboardDocumentsRoute: DashboardDocumentsRoute,
  DashboardFocusRoute: DashboardFocusRoute,
  DashboardOrdersRoute: DashboardOrdersRoute,
  DashboardPackageOptionsRoute: DashboardPackageOptionsRoute,
  DashboardPackagesPriceRoute: DashboardPackagesPriceRoute,
  DashboardPickupScheduleRoute: DashboardPickupScheduleRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardStatisticsRoute: DashboardStatisticsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardOrderAddRoute: DashboardOrderAddRoute,
  DashboardUsersUserIdRoute: DashboardUsersUserIdRoute,
  DashboardCategoriesIndexRoute: DashboardCategoriesIndexRoute,
  DashboardOrderIndexRoute: DashboardOrderIndexRoute,
  DashboardTariffsIndexRoute: DashboardTariffsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardOrderOrderIdEditRoute: DashboardOrderOrderIdEditRoute,
  DashboardTariffConfigurationAddRoute: DashboardTariffConfigurationAddRoute,
  DashboardCategoriesCategoryIdIndexRoute:
    DashboardCategoriesCategoryIdIndexRoute,
  DashboardOrderOrderIdIndexRoute: DashboardOrderOrderIdIndexRoute,
  DashboardOrderAccumulatorsIndexRoute: DashboardOrderAccumulatorsIndexRoute,
  DashboardTariffConfigurationIndexRoute:
    DashboardTariffConfigurationIndexRoute,
  DashboardCategoriesCategoryIdTariffsAddRoute:
    DashboardCategoriesCategoryIdTariffsAddRoute,
  DashboardTariffConfigurationConfigurationIdEditRoute:
    DashboardTariffConfigurationConfigurationIdEditRoute,
  DashboardOrderAccumulatorsAccumulatorIdIndexRoute:
    DashboardOrderAccumulatorsAccumulatorIdIndexRoute,
  DashboardCategoriesCategoryIdTariffsTariffIdEditRoute:
    DashboardCategoriesCategoryIdTariffsTariffIdEditRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  PaymentsSecure3dsRoute: PaymentsSecure3dsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
